import { connect } from 'react-redux';

import CommitmentUpsellModal from '../components/CommitmentUpsellModal';
import {
  changeCommitmentUpsellModalVisibility,
  reportEvergreenOffering,
} from '../actions';
import { getOfferingName } from '../selectors';

export const mapStateToProps = (state, props) => ({
  variantName: getOfferingName(props.offering, state),
  minimumPodPacks: state.minimumSubscriptionItems,
  isOpen: state.commitmentUpsellModalIsOpen,
});

export const mapDispatchToProps = dispatch => ({
  handleClose: () => {
    dispatch(changeCommitmentUpsellModalVisibility(false));
  },
  reportEvergreenOffering: offering => {
    dispatch(reportEvergreenOffering(offering));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommitmentUpsellModal);
